import React from 'react'
import Navbar from './Components/Navbar'
import ProfileModel from './Components/Profile/Profile'
import Search from './Components/Search'
import { useGlobalContext } from '../../Context/Authentation'
import { Outlet } from 'react-router-dom'
import Footer from '../Footer/Footer'

export default function Header() {
    const { user } = useGlobalContext();
    return (
        <>
            <Navbar />
            <ProfileModel pic={user?.pic} name={user?.name} email={user?.email} />
            <Search />
            <br />
            <Outlet />
            <Footer />
        </>
    )
}
